import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const Notifications = ({ isSidebarClosed, setIsSidebarClosed }) => {
  return (
    <div>
        <Navbar isSidebarClosed={isSidebarClosed} setIsSidebarClosed={setIsSidebarClosed} />
        <Sidebar isCollapsed={isSidebarClosed} setIsCollapsed={setIsSidebarClosed} />
        <div className="page-content">
          <h2>Értesítések</h2>
          <p>Itt találod az értesítéseidet.</p>
        </div>
    </div>
  );
};

export default Notifications; 